import { eBonusType } from "../Bonuses/Bonus";


export const enum eCellType {
    /**
     * Bunka obsahuje dlazdici
     */
    tile,
    /**
     * Bunka obsahuje pojizdnou plosinu
     */
    platform,
    /**
     * Bunka je prozatim prazdna (obsahovala nebo bude obsahovat napr. pojizdnou plosinu)
     */
    empty,
}



/**
 * Typ dlazdic
 */
export const enum eTileType {
    solid = 1,
    fragile,
    trampoline,
    fan,

    LENGTH
}



/**
 * Bunka preddefinovane mapy
 */
export class MapCell {
    /**
     * Typ bunky
     */
    cellType: eCellType;

    /**
     * Typ dlazdice
     */
    tileType: eTileType;

    /**
     * Verze dlazdice
     */
    tileVersion: number;

    /**
     * Typ sebratelneho predmetu (-1, pokud na bunce zadny pickup neni)
     */
    bonusType: eBonusType;

    /**
     * Skupina pickupu (hrac zna skupinu, ze ktere sebral posledni pickup a podle toho vypocitava skore)
     */
    bonusGroupMark: number;

    static readonly TILE_TYPE_MASK = 0x000F;
    static readonly TILE_TYPE_SHIFT = 0;

    static readonly TILE_VERSION_MASK = 0x0003;
    static readonly TILE_VERSION_SHIFT = MapCell.TILE_TYPE_SHIFT + 4;

    static readonly BONUS_TYPE_MASK = 0x0003;
    static readonly BONUS_TYPE_SHIFT = MapCell.TILE_VERSION_SHIFT + 2;

    static readonly BONUS_GROUP_MASK = 0x0001;
    static readonly BONUS_GROUP_SHIFT = MapCell.BONUS_TYPE_SHIFT + 2;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(cellData: number): void {
        // Typ dlazdice
        this.tileType = (cellData >> MapCell.TILE_TYPE_SHIFT) & MapCell.TILE_TYPE_MASK;

        if (this.tileType < eTileType.LENGTH) {
            this.cellType = eCellType.tile;

            // Verze dlazdice
            this.tileVersion = (cellData >> MapCell.TILE_VERSION_SHIFT) & MapCell.TILE_VERSION_MASK;
        }
        else {
            // Bunka je bud prazdna nebo obsahuje pojizdnou plosinu
            this.cellType = eCellType.platform + (this.tileType - eTileType.LENGTH);
            this.tileType = -1;
        }

        // Sebratelny predmet
        if ((this.bonusType = ((cellData >> MapCell.BONUS_TYPE_SHIFT) & MapCell.BONUS_TYPE_MASK) - 1) >= 0)
            // Znacka skupiny
            this.bonusGroupMark = (cellData >> MapCell.BONUS_GROUP_SHIFT) & MapCell.BONUS_GROUP_MASK;
    }
}